import prepareOptions from '../../prepareOptions';
import {
  ALCANTARA,
  CLOTH,
  LEATHER,
  PART_LEATHER,
  SYNTHETIC_LEATHER,
  PLASTIC,
  VELOUR,
  OTHER,
} from './values';

export default prepareOptions([
  {
    value: ALCANTARA,
    label: __('carDetails.upholstery.alcantara'),
  },
  {
    value: CLOTH,
    label: __('carDetails.upholstery.cloth'),
  },
  {
    value: LEATHER,
    label: __('carDetails.upholstery.leather'),
  },
  {
    value: PART_LEATHER,
    label: __('carDetails.upholstery.partLeather'),
  },
  {
    value: SYNTHETIC_LEATHER,
    label: __('carDetails.upholstery.syntheticLeather'),
  },
  {
    value: PLASTIC,
    label: __('carDetails.upholstery.plastic'),
  },
  {
    value: VELOUR,
    label: __('carDetails.upholstery.velour'),
  },
  {
    value: OTHER,
    label: __('carDetails.upholstery.other'),
  },
]);
